import { render } from "./ContactSyncDashboard.vue?vue&type=template&id=70530be7&scoped=true"
import script from "./ContactSyncDashboard.vue?vue&type=script&lang=js"
export * from "./ContactSyncDashboard.vue?vue&type=script&lang=js"

import "./ContactSyncDashboard.vue?vue&type=style&index=0&id=70530be7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70530be7"]])

export default __exports__